module.exports = __webpack_public_path__ + "media/images/application/favicon/safari-pinned-tab-7adaae5ca32fe5694c7aad33e77dadd4.svg";